import { Directive } from 'vue';

export function decimalFormatter(el: HTMLElement, { value }: { value: number }) {
   const input = el.querySelector('input');

   const max = value;

   if (!input || input.value === '') return;

   const inputValue = parseFloat(input.value);

   if (inputValue > max) {
      input.value = max.toString();
   }
}

const maxValueDirective: Directive = {
   mounted: decimalFormatter,
   updated: decimalFormatter,
};

export default maxValueDirective;
